// 导入自己需要的组件
import {Timeline, TimelineItem, Tag, Link, Aside, Container, Main, Divider,Table,TableColumn} from 'element-ui'

const element = {
    install: function (Vue) {
        Vue.use(Timeline)
        Vue.use(TimelineItem)
        Vue.use(Tag)
        Vue.use(Link)
        Vue.use(Aside)
        Vue.use(Container)
        Vue.use(Main)
        Vue.use(Divider)
        Vue.use(Table)
        Vue.use(TableColumn)
    }
}
export default element
